module.exports = __webpack_public_path__ + "static/media/bfile-life-stage-3.7b08f4a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bfile-life-stage-3.png
// module id = 2668
// module chunks = 0